import React from "react"
import {
  QuickStartArticle,
  QuickStartMainTextContainer,
} from "./quick-start.styled"
import RichText from "../../../../../resolvers/rich-text/rich-text.resolver"
import { AppFunctionComponent, TextBuilder } from "../../../../../types"
import { SectionLayout } from "../../section.component"
import styled from "styled-components"

interface QuickStartHeadingTextProps {
  headingText: TextBuilder
}

const QuickStartHeadingText: AppFunctionComponent<
  QuickStartHeadingTextProps
> = ({ headingText }) => {
  return (
    <StyledQuickStartMainTextContainer layout={SectionLayout.TwoCols} as="div">
      {headingText.text && (
        <QuickStartArticle>
          <RichText content={headingText.text} />
        </QuickStartArticle>
      )}
      {headingText.secondText && (
        <QuickStartArticle area={"SecondArticle"}>
          <RichText content={headingText.secondText} />
        </QuickStartArticle>
      )}
    </StyledQuickStartMainTextContainer>
  )
}

export default QuickStartHeadingText

const StyledQuickStartMainTextContainer = styled(QuickStartMainTextContainer)`
  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    grid-template-areas:
      "Article SecondArticle"
      "Article SecondArticle";
    grid-template-columns: 1.2fr 1fr;
    grid-column-gap: 70px;
  }

  ${QuickStartArticle} {
    h1 {
      font-family: Facto;
      font-size: 36px;
      font-weight: 400;
      line-height: 43.2px;
      text-align: left;
    }
    h1,
    h2,
    h3,
    h4,
    p {
      text-align: left;
    }
  }
`
